export default __webpack_public_path__ + "static/media/red_line.404240be.svg";